module.exports = __webpack_public_path__ + "img/arrow-orange.da179c5e.svg";